<template>
  <div>
    <v-card flat rounded="lg" class="py-10 px-10 mb-10">
      <v-list rounded>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('project.my_project') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MenuLeft",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
